import React, { useState } from "react";
import dayjs from '../../utils/dayjs-setup';
import { Button, Card, CardContent, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormLabel, GridLegacy as Grid, MenuItem, Select, Typography } from '@mui/material';
import { AxiosInstance, DateFormatString, EstadosPedido, FormatPrice } from "../../utils/constants";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { AutoCompleteInputWithLabel } from "../form/custom-imputs";



const ProductItemPedido = (props) => {



    return <Card>
        <CardContent>
            <Grid container >
                <Grid items md={12} >
                    <Typography variant='p' >
                        {props.nombre_producto} - {props.calidad_producto}
                    </Typography>
                </Grid>
                <Grid items md={12} >

                    <Typography variant='p' >
                        Cantidad solicitada: {props.cantidad}
                    </Typography>
                </Grid>
                {props.precio_unitario && <Grid items md={12} >

                    <Typography variant='p' >
                        Precio de venta: $ {props.precio_unitario} X {props.cod_erp_producto}
                    </Typography>
                </Grid>}

                <Grid items md={12} >

                    <Typography variant='p' >
                        Valor total: $ {FormatPrice(props.vlr_subtotal)}
                    </Typography>
                </Grid>
            </Grid>
        </CardContent>

    </Card>

}

const schema = yup.object({
    centro_operacion_entrada: yup.object().shape({
        label: yup.string(),
        value: yup.number()
    }).test("is_selected", (value, ctx) => {

        if (!value.value) {
            return ctx.createError({ message: 'Seleccione una opcion' })
        }
        return true;
    }),
    centro_operacion_salida: yup.object().shape({
        label: yup.string(),
        value: yup.number()
    }).test("is_selected", (value, ctx) => {

        if (!value.value) {
            return ctx.createError({ message: 'Seleccione una opcion' })
        }
        return true;
    }),
}).required();

export const ModalLanzarNecesidad = ({
    visibleModal,
    productInfo = {},
    onCloseModal = () => { },
    LanzarNecesidades = ()=>{}

}) => {

    const [EstateSelected, setEstateSeled] = useState(productInfo.estado_pedido_cod);
    const [Centrada,setCentrada] = useState();
    const [CSalida,setCSalida] = useState([]);

    const { control,handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            centro_operacion_entrada: null,
            centro_operacion_salida: null
        }
    });


    const lanzarProceso = (values) => {
        const payload = {
            fecha_entrega:productInfo.fecha_entrega,
            cod_centro_op_entrada:values.centro_operacion_entrada.value,
            cod_centro_op_salida:values.centro_operacion_salida.value,
            detalle:productInfo.detalle_pedido.map(item=>{
                return {
                    cod_producto:item.cod_producto,
                    cod_unidad_medida:item.cod_unidad_medida,
                    cantidad:item.cantidad,
                    cod_detalle_pedido:item.cod
                }
            })
        }
        LanzarNecesidades(payload);
        console.log({
            values,
            payload
        });
    }


    const onSearchCentroOp = async (value_search, type_enter) => {

        if (value_search) {
            try {

                const { data: { value } } = await AxiosInstance.post("maestros-marketplace/get-centros-operacion-filtros", {
                    search_query: value_search
                });
                if ( type_enter == 'IN'){
                    setCentrada(value);
                }else{
                    setCSalida(value);
                }
                return value;
            } catch (e) {
                return [];
            }

        }



    }

    return (
        <Dialog
            open={visibleModal}
        >
            <DialogTitle>
                Lanzar necesidades apartir de un pedido
            </DialogTitle>
            <DialogContent>
                <Grid container  >
                    <Grid items sm={12} md={12} >
                        <Typography variant='p'  >
                            <strong>Cliente:</strong> {productInfo.nombre_cliente}
                        </Typography>
                    </Grid>
                    <Grid items sm={12} md={12} >
                        <Typography variant='p' >
                            <strong>Municipio:</strong> {productInfo.municipio_descripcion}
                        </Typography>
                    </Grid>
                    <Grid items sm={12} md={12} >
                        <Typography variant='p' >
                            <strong>Direccion:</strong> {productInfo.sucursal_direccion}
                        </Typography>
                    </Grid>
                    <Grid items sm={6} md={6} >
                        <Typography variant='p' >
                            <strong>Celular 1:</strong> {productInfo.celular_notificaciones}
                        </Typography>
                    </Grid>
                    <Grid items sm={6} md={6} >
                        <Typography variant='p' >
                            <strong>Celular 2:</strong> {productInfo.sucursal_telefono}
                        </Typography>
                    </Grid>
                    <Grid items sm={12} md={12} >
                        <Typography variant='p' >
                            <strong>Fecha de entrega:</strong> {dayjs(productInfo.fecha_entrega).format(DateFormatString)}
                        </Typography>
                    </Grid>
                    <Grid items sm={12} md={12} sx={{ marginTop: '15px', }} >
                        <Typography variant="p" fontSize={'1rem'} fontWeight={"bold"} >
                            Listado de productos
                        </Typography>
                    </Grid>
                    <Grid items sm={12} md={12} >
                        {
                            productInfo.detalle_pedido?.map(pedido_item => <ProductItemPedido
                                {...pedido_item}
                            />)
                        }
                    </Grid>
                    <Grid items sm={12} md={12} sx={{ marginTop: '15px', }} >
                        <Typography variant="p" fontSize={'1rem'} fontWeight={"bold"} >
                            Configuracion de la necesidad
                        </Typography>
                    </Grid>

                    <Grid items sm={12} md={12} sx={{ marginTop: '15px', }} >
                        <form onSubmit={handleSubmit(lanzarProceso)} >
                            <Grid container >
                                <Grid item md={6} >
                                    <Controller
                                        control={control}
                                        name="centro_operacion_entrada"
                                        render={({ field }) => <AutoCompleteInputWithLabel
                                            label='Centro de operacion de entrada'
                                            size='small'
                                            fullWidth={true}
                                            multiple={false}
                                            errorMessage={errors[field.name]?.message}
                                            PopperComponent={(props) => <div hidden={!props.open} >

                                                {props.children}
                                            </div>}
                                            onInputChange={(evt,value)=>onSearchCentroOp(value,'IN')}
                                            options={Centrada || []}
                                            noOptionsText="Lista vacia"
                                            getOptionLabel={(option) => option.label}
                                            isOptionEqualToValue={(option, value) => option.value === value.value}
                                            filterOptions={(x) => x}
                                            {...field}
                                        />}
                                    />
                                </Grid>
                                <Grid item md={6} >
                                    <Controller
                                        control={control}
                                        name="centro_operacion_salida"
                                        render={({ field }) => <AutoCompleteInputWithLabel
                                            label='Centro de operacion de salida'
                                            size='small'
                                            fullWidth={true}
                                            multiple={false}
                                            errorMessage={errors[field.name]?.message}
                                            PopperComponent={(props) => <div hidden={!props.open} >

                                                {props.children}
                                            </div>}
                                            onInputChange={(evt,value)=>onSearchCentroOp(value,'OUT')}
                                            options={CSalida || []}
                                            noOptionsText="Lista vacia"
                                            getOptionLabel={(option) => option.label}
                                            isOptionEqualToValue={(option, value) => option.value === value.value}
                                            filterOptions={(x) => x}
                                            {...field}
                                        />}
                                    />
                                </Grid>
                                <Grid item md={12} marginTop='10px' >
                                    <Button 
                                   
                                    size="small" 
                                    type="submit" 
                                    variant="contained" >Crear necesidades</Button>
                                </Grid>
                            </Grid>

                        </form>
                    </Grid>



                </Grid>
            </DialogContent>
            <DialogActions>
                <Button size="small" onClick={onCloseModal} variant='contained' color='secondary' >Cerrar ventana</Button>

            </DialogActions>
        </Dialog>
    )

}